exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account .account-name[data-v-501deb04] {\n  overflow: hidden;\n  height: 3em;\n}\n.account .account-info-summary[data-v-501deb04] {\n  color: white;\n}\n.add-new-account[data-v-501deb04] {\n  border: 5px dotted rgba(0, 0, 0, 0.2);\n  height: 100%;\n}", ""]);

// exports
